/**
 * SKOP Report Badge
 *
 * Warning badge shown when a token has community reports.
 */

import { getTokenReportSummary } from '../lib/reports';

interface ReportBadgeProps {
  tokenAddress: string;
  onClick?: () => void;
}

export function ReportBadge({ tokenAddress, onClick }: ReportBadgeProps) {
  const summary = getTokenReportSummary(tokenAddress);

  if (!summary || summary.totalReports === 0) {
    return null;
  }

  const hasVerified = summary.verifiedReports > 0;

  return (
    <button
      onClick={onClick}
      style={{
        display: 'inline-flex',
        alignItems: 'center',
        gap: '4px',
        padding: '4px 8px',
        fontSize: '11px',
        fontWeight: 600,
        background: hasVerified ? 'rgba(255, 59, 59, 0.15)' : 'rgba(255, 184, 0, 0.15)',
        color: hasVerified ? '#ff3b3b' : '#ffb800',
        border: `1px solid ${hasVerified ? 'rgba(255, 59, 59, 0.3)' : 'rgba(255, 184, 0, 0.3)'}`,
        borderRadius: 'var(--radius-sm)',
        cursor: 'pointer',
        transition: 'all 0.15s ease',
      }}
      title={`${summary.totalReports} community report${summary.totalReports > 1 ? 's' : ''}`}
    >
      <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
        <path d="M10.29 3.86L1.82 18a2 2 0 0 0 1.71 3h16.94a2 2 0 0 0 1.71-3L13.71 3.86a2 2 0 0 0-3.42 0z"/>
        <line x1="12" y1="9" x2="12" y2="13"/>
        <line x1="12" y1="17" x2="12.01" y2="17"/>
      </svg>
      <span>{summary.totalReports} report{summary.totalReports > 1 ? 's' : ''}</span>
      {hasVerified && (
        <span style={{
          padding: '1px 4px',
          fontSize: '9px',
          background: 'rgba(255, 59, 59, 0.2)',
          borderRadius: '2px',
        }}>
          {summary.verifiedReports} verified
        </span>
      )}
    </button>
  );
}
